import queryString from 'query-string';
import { isWeb } from '../device-info';
import { radar } from '../log';
import { getQuery } from '@/common/const';

const getCurTag = (params: { bundleId }) => {
    const { bundleId } = params;

    let curTag = bundleId;

    // 针对商详页特殊处理
    if (bundleId === 'Detail') {
        const curSource = getQuery('source');
        if (['ShoppingCar', 'EcomRecommendGoodsSingle', 'EcomRecommendGoods'].includes(curSource)) {
            curTag += curSource;
        } else if (['DetailShoppingCar', 'DetailEcomRecommendGoodsSingle', 'DetailEcomRecommendGoods'].includes(curSource)) {
            curTag = curSource;
        }
    }

    return curTag;
};

// 跳转之前配置下一个页面的source
export const getSource = () => {
    let curTag;
    if (isWeb) {
        const pathname = window.location.pathname;
        const querys = queryString.parseUrl(window.location.href).query;
        const redirectUrl = queryString.parse((querys.redirectUrl || querys.krnuselessurl || '') as string);
        const bundleId =
            redirectUrl.bundleId ||
            pathname
                .replace(/[\/\-]/g, '_')
                .replace(/^_+|_+$/g, '') //移除首尾的下划线
                .split('_')
                .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                .join('');
        if (!bundleId) {
            radar.event({
                name: 'EcomUnhandledSource',
                params: {
                    pathname,
                    url: window.location.href,
                },
            });
        }
        curTag = getCurTag({
            bundleId,
        });
    } else {
        const bundleId = getQuery('bundleId');
        curTag = getCurTag({
            bundleId,
        });
    }
    return curTag;
};

export const getH5Source = () => {
    const pathname = window.location.pathname
        .replace(/[\/\-]/g, '_')
        .replace(/^_+|_+$/g, '') //移除首尾的下划线
        .split('_')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join('');

    return pathname;
};
